module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAFCAYAAADxCTo8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAUklEQVQ4y2NkGOYgLS3tPgMDwwEGBob9DAwMh2bNmvUAmzrGgXYoHQLiP5rQAwYsAcOIReFIAwcZGBgaR2qKOMQASREHYCmCZaAdSgeA1ePoAAAw4SBLMJLMcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/jt.png
// module id = fjSV
// module chunks = 1